export default function RingCentralProviderIcon() {
  return (
    <svg viewBox='0 0 32 32' className='w-6 h-6' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='32' height='32' rx='6' fill='#0671CE' />
      <path
        d='M16 6C10.5 6 6 10.5 6 16C6 21.5 10.5 26 16 26C21.5 26 26 21.5 26 16C26 10.5 21.5 6 16 6ZM16 22C12.7 22 10 19.3 10 16C10 12.7 12.7 10 16 10C19.3 10 22 12.7 22 16C22 19.3 19.3 22 16 22Z'
        fill='white'
      />
      <path
        d='M16 12C13.8 12 12 13.8 12 16C12 18.2 13.8 20 16 20C18.2 20 20 18.2 20 16C20 13.8 18.2 12 16 12ZM16 18C14.9 18 14 17.1 14 16C14 14.9 14.9 14 16 14C17.1 14 18 14.9 18 16C18 17.1 17.1 18 16 18Z'
        fill='white'
      />
    </svg>
  );
}
